import { addOfficeType } from "../../../../../actions/Utilities/OfficeType";
import { useMutation } from "react-query";

const useAddOfficeType = () => {
  return useMutation(addOfficeType);
};
export default useAddOfficeType;
